// "My Advisor" di sidebar = nama recommender/upline merchant, sumbernya `recommenderName`
// dari GET /api/v1/partner/ (endpoint yang sama dipakai Dashboard buat referral code).
//
// Dua hal dari kontrak BE yang nentuin bentuk modul ini:
// 1. DTO-nya `json:"recommenderName,omitempty"` — merchant tanpa upline GAK punya key-nya
//    sama sekali, bukan string kosong. Mayoritas merchant kondisinya begini (dev: 1967 dari
//    2209 company `referrer_account_id`-nya NULL), jadi empty state itu jalur normal, bukan edge.
// 2. Nilainya statis sepanjang sesi, tapi sidebar nempel di semua halaman /admin — sementara
//    yang manggil getCompany() cuma Dashboard. Makanya di-cache di sessionStorage biar reload
//    di halaman non-dashboard gak nampilin '-' sekejap sebelum data balik.
import partnerService from './api/partnerService';

const STORAGE_KEY = 'skai1AdvisorName';
export const ADVISOR_UPDATED_EVENT = 'advisor:updated';

export function loadAdvisor(){
  try{
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw === null ? null : JSON.parse(raw);
  }catch(error){
    return null;
  }
}

export function saveAdvisor(name){
  // Normalisasi ke string: key absen, null, atau spasi doang → '' (dirender jadi '-').
  const value = typeof name === 'string' ? name.trim() : '';
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  window.dispatchEvent(new CustomEvent(ADVISOR_UPDATED_EVENT, { detail: value }));
  return value;
}

export async function refreshAdvisor(){
  try{
    const response = await partnerService.getCompany();
    if(response && response.code === 'OK' && response.data){
      saveAdvisor(response.data.recommenderName);
    }
  }catch(error){
    // Nama advisor cuma info pelengkap di sidebar — gagal fetch jangan ganggu app.
  }
}

export function clearAdvisorState(){
  sessionStorage.removeItem(STORAGE_KEY);
}

// Consent "Merchant Advisor Support" (SKAI1-1457) SENGAJA gak di-cache kayak nama advisor:
// Owner/Admin lain bisa ngubah kapan aja, dan toggle wajib nampilin nilai yang tersimpan di BE.
// Makanya tiap modal Details dibuka → GET /partner/ baru.
//
// `advisorConsent: null` (BE belum init) atau key absen (BE lama tanpa fitur ini) = BELUM
// TERSEDIA. Jangan dianggap OFF, dan jangan bikin default ON sendiri di FE.
function normalizeConsent(consent){
  return consent && typeof consent.enabled === 'boolean' ? consent : null;
}

// Interceptor axios nge-RESOLVE response error yang punya `code` (400/403/404/500), jadi
// cek `code === 'OK'` — try/catch cuma nangkep network error/timeout (yang udah di-toast global).
export async function fetchAdvisorConsent(){
  try{
    const response = await partnerService.getCompany();
    if(response && response.code === 'OK' && response.data){
      // `name` buat nyegerin sidebar — yang manggil saveAdvisor itu modal, sesudah cek response basi.
      return { ok: true, consent: normalizeConsent(response.data.advisorConsent), name: response.data.recommenderName };
    }
    return { ok: false, code: response ? response.code : null };
  }catch(error){
    return { ok: false, code: null };
  }
}

// PUT balikin object consent-nya langsung sebagai `data` (bukan dibungkus advisorConsent).
export async function updateAdvisorConsent(enabled){
  try{
    const response = await partnerService.updateAdvisorConsent(enabled);
    const consent = response && response.code === 'OK' ? normalizeConsent(response.data) : null;
    return consent ? { ok: true, consent } : { ok: false, code: response ? response.code : null };
  }catch(error){
    return { ok: false, code: null };
  }
}

// Role partner cuma ada di localStorage `userData.roles.partner` (snapshot login/refresh token),
// konvensi [0] sama kayak User.js. Dibaca pas modal dibuka aja, bukan tiap render.
export function loadPartnerRole(){
  try{
    const userData = JSON.parse(localStorage.getItem('userData') || 'null');
    return userData?.roles?.partner?.[0] ?? null;
  }catch(error){
    return null;
  }
}
